export const encodeCsv = (rows: string[]) => {
  return new Blob([rows.join('\n')], {
    type: 'text/csv;charset=utf-8',
  })
}

export const exportToCsv = (rows: string[]) => {
  const encodedCsvContent = encodeCsv(rows)
  const url = URL.createObjectURL(encodedCsvContent)
  window.location.assign(url)
  URL.revokeObjectURL(url)
}
